import React, { useState } from 'react';
import axios from '../../../Axiosinstance';
import { TextField, Checkbox, FormControlLabel, Button, Typography, Box, Snackbar, IconButton } from '@mui/material';
import { Add, Delete } from '@mui/icons-material'; // Import Material-UI icons
import { useNavigate } from 'react-router-dom';

const Newcompany = ({ onCourseCreated }) => {
  const [formData, setFormData] = useState({
    clientCompanyName: '',
    uen: '',
    companyAddress: '',
    postalCode: '',
    billingAddress: '',
    emailId: '',
    contacts: [
      {
        contactNumber: '',
        contactPerson: '',
        contactDesignation: '',
        contactEmail: '',
      },
    ],
    companyMobileNumbers: [''],
    companyTelephoneNumbers: [''],
    companyEmails: [''],
    contactMobileNumbers: [''],
    contactEmails: [''],
    contactTelephoneNumbers: [''],
  });

  const [uenAvailable, setUENAvailable] = useState(true);
  const [uenMessage, setUENMessage] = useState('');
  const [showBillingAddress, setShowBillingAddress] = useState(false);
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [companyMobileNumbers, setCompanyMobileNumbers] = useState(['']);
  const [companyTelephoneNumbers, setCompanyTelephoneNumbers] = useState(['']);
  const [companyEmails, setCompanyEmails] = useState(['']);
  const [contactMobileNumbers, setContactMobileNumbers] = useState(['']);
  const [contactTelephoneNumbers, setContactTelephoneNumbers] = useState(['']);
  const [contactEmails, setContactEmails] = useState(['']);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDynamicFieldChange = (setState, index, value) => {
    setState((prevData) =>
      prevData.map((item, idx) => (idx === index ? value : item))
    );
  };



  const handleUENBlur = () => {
    if (formData.uen === 'UEN12345') {
      setUENAvailable(false);
      setUENMessage('UEN already exists');
    } else {
      setUENAvailable(true);
      setUENMessage('');
    }
  };

  const handleCheckboxChange = () => {
    setShowBillingAddress((prev) => !prev);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Prepare the data by merging all dynamic fields into formData
    const updatedFormData = {
      ...formData,
      companyPhoneNumbers: companyMobileNumbers.filter((num) => num.trim() !== ""),
      companyTelephoneNumbers: companyTelephoneNumbers.filter((num) => num.trim() !== ""),
      companyEmails: companyEmails.filter((email) => email.trim() !== ""),
      contacts: formData.contacts.map((contact, index) => ({
        ...contact,
        contactPhoneNumbers: contactMobileNumbers.filter((num) => num.trim() !== ""),
        contactTelephoneNumbers: contactTelephoneNumbers.filter((num) => num.trim() !== ""),
        contactEmails: contactEmails.filter((email) => email.trim() !== ""),
      })),
    };

    try {
      const response = await axios.post('/wsq/companies/registerCompanyWithoutContacts', updatedFormData);
      console.log("Server Response:", response.data);
      setOpenSuccessSnackbar(true);
      onCourseCreated();
      // Optionally navigate to another page
      // setTimeout(() => {
      //   navigate('/dashboard');
      // }, 2000);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const handleNavigate = () => {
    if (onCourseCreated && typeof onCourseCreated === 'function') {
      onCourseCreated(); // Ensure the function exists before calling it
    }
  };



  // Functions to handle adding and removing mobile numbers, telephone numbers, and emails
  const addField = (field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: [...prevData[field], ''],
    }));
  };


  const handleContactChange = (contactIndex, e) => {
    const { name, value } = e.target;
    const updatedContacts = [...formData.contacts];
    updatedContacts[contactIndex][name] = value;
    setFormData({ ...formData, contacts: updatedContacts });
  };

  const removeField = (field, index) => {
    const updatedFields = formData[field].filter((_, idx) => idx !== index);
    setFormData((prevData) => ({
      ...prevData,
      [field]: updatedFields,
    }));
  };

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto', p: 3, borderRadius: 3, boxShadow: 2 }}>
      <Typography variant="h6" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 4 }}>
        Company Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Client Company Name"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          name="clientCompanyName"
          value={formData.clientCompanyName}
          onChange={handleChange}
        />
        <TextField
          label="UEN"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          name="uen"
          value={formData.uen}
          onChange={handleChange}
          onBlur={handleUENBlur}
          error={!uenAvailable}
          helperText={uenMessage}
        />

        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          name="emailId"
          value={formData.emailId}
          onChange={handleChange}
        />

        {/* Company Mobile Numbers */}
        {companyMobileNumbers.map((number, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <TextField
              label="Company Mobile Number"
              variant="outlined"
              fullWidth
              required
              value={number}
              error={!(number.match(/^[689]\d{0,7}$/) || number === '')}
              helperText={
                !(number.match(/^[689]\d{0,7}$/) || number === '')
                  ? 'Number must start with 6, 8, or 9 and be 8 digits long'
                  : ''
              }
              onChange={(e) => {
                const value = e.target.value;
                // Allow empty value or validate the first digit and subsequent digits
                if (
                  value === '' || // Allow clearing the input
                  (value.length === 1 && /^[689]$/.test(value)) || // Validate first digit
                  (value.length > 1 && /^[689]\d*$/.test(value) && value.length <= 8) // Validate up to 8 digits
                ) {
                  handleDynamicFieldChange(setCompanyMobileNumbers, index, value);
                }
              }}
            />
            {companyMobileNumbers.length > 1 && (
              <IconButton onClick={() => setCompanyMobileNumbers((prev) => prev.filter((_, i) => i !== index))} color="error">
                <Delete />
              </IconButton>
            )}
            {/* Only display the + icon for the first field */}
            {index === 0 && (
              <IconButton onClick={() => setCompanyMobileNumbers((prev) => [...prev, ''])} color="primary">
                <Add />
              </IconButton>
            )}
          </div>
        ))}


        {/* Company Telephone Numbers */}
        {companyTelephoneNumbers.map((number, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <TextField
              label="Company Telephone Number"
              variant="outlined"
              fullWidth
              required
              value={number}
              error={!(number.match(/^6\d{0,7}$/) || number === '')}
              helperText={
                !(number.match(/^6\d{0,7}$/) || number === '')
                  ? 'Number must start with 6 and be 8 digits long'
                  : ''
              }
              onChange={(e) => {
                const value = e.target.value;
                // Allow empty value or validate the first digit and subsequent digits
                if (
                  value === '' || // Allow clearing the input
                  (value.length === 1 && value === '6') || // Validate first digit (only 6)
                  (value.length > 1 && /^6\d*$/.test(value) && value.length <= 8) // Validate up to 8 digits
                ) {
                  handleDynamicFieldChange(setCompanyTelephoneNumbers, index, value);
                }
              }}
            />
            {companyTelephoneNumbers.length > 1 && (
              <IconButton onClick={() => setCompanyTelephoneNumbers((prev) => prev.filter((_, i) => i !== index))} color="error">
                <Delete />
              </IconButton>
            )}
            {/* Only display the + icon for the first field */}
            {index === 0 && (
              <IconButton onClick={() => setCompanyTelephoneNumbers((prev) => [...prev, ''])} color="primary">
                <Add />
              </IconButton>
            )}
          </div>
        ))}


        {/* Company Emails */}
        {companyEmails.map((email, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <TextField
              label=" Addtional Company Email"
              variant="outlined"
              fullWidth
              required
              value={email}
              onChange={(e) => handleDynamicFieldChange(setCompanyEmails, index, e.target.value)}
            />
            {companyEmails.length > 1 && (
              <IconButton onClick={() => setCompanyEmails((prev) => prev.filter((_, i) => i !== index))} color="error">
                <Delete />
              </IconButton>
            )}
            {/* Only display the + icon for the first field */}
            {index === 0 && (
              <IconButton onClick={() => setCompanyEmails((prev) => [...prev, ''])} color="primary">
                <Add />
              </IconButton>
            )}
          </div>
        ))}

        <TextField
          label="Company Address"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          name="companyAddress"
          value={formData.companyAddress}
          onChange={handleChange}
        />
        <TextField
          label="Postal Code"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          name="postalCode"
          value={formData.postalCode}
          onChange={handleChange}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={showBillingAddress}
              onChange={handleCheckboxChange}
              color="primary"
            />
          }
          label="Same as Company Address"
        />
        <TextField
          label="Billing Address"
          variant="outlined"
          fullWidth
          margin="normal"
          multiline
          rows={4}
          name="billingAddress"
          value={formData.billingAddress}
          onChange={handleChange}
          disabled={showBillingAddress}
        />

        <Typography variant="h6" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 4 }}>
          Incharge Details  Form
        </Typography>



        {formData.contacts.map((contact, contactIndex) => (
          <div key={contactIndex}>
            <TextField
              label="Contact Person"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              name="contactPerson"
              value={contact.contactPerson}
              onChange={(e) => handleContactChange(contactIndex, e)}
            />

            <TextField
              label="Contact Designation"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              name="contactDesignation"
              value={contact.contactDesignation}
              onChange={(e) => handleContactChange(contactIndex, e)}
            />


            {/* Contact Mobile Numbers */}
            {contactMobileNumbers.map((number, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <TextField
                  label="Contact Mobile Number"
                  variant="outlined"
                  fullWidth
                  required
                  value={number}
                  error={!(number.match(/^[689]\d{0,7}$/) || number === '')}
                  helperText={
                    !(number.match(/^[689]\d{0,7}$/) || number === '')
                      ? 'Number must start with 6, 8, or 9 and be 8 digits long'
                      : ''
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow empty value or validate the first digit and subsequent digits
                    if (
                      value === '' || // Allow clearing the input
                      (value.length === 1 && /^[689]$/.test(value)) || // Validate first digit
                      (value.length > 1 && /^[689]\d*$/.test(value) && value.length <= 8) // Validate up to 8 digits
                    ) {
                      handleDynamicFieldChange(setContactMobileNumbers, index, value);
                    }
                  }}
                />
                {contactMobileNumbers.length > 1 && (
                  <IconButton onClick={() => setContactMobileNumbers((prev) => prev.filter((_, i) => i !== index))} color="error">
                    <Delete />
                  </IconButton>
                )}
                {/* Only display the + icon for the first field */}
                {index === 0 && (
                  <IconButton onClick={() => setContactMobileNumbers((prev) => [...prev, ''])} color="primary">
                    <Add />
                  </IconButton>
                )}
              </div>
            ))}

            {/* Contact Telephone Numbers */}
            {contactTelephoneNumbers.map((number, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <TextField
                  label="Contact Telephone Number"
                  variant="outlined"
                  fullWidth
                  required
                  value={number}
                  error={!(number.match(/^6\d{0,7}$/) || number === '')}
                  helperText={
                    !(number.match(/^6\d{0,7}$/) || number === '')
                      ? 'Number must start with 6 and be 8 digits long'
                      : ''
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow empty value or validate the first digit and subsequent digits
                    if (
                      value === '' || // Allow clearing the input
                      (value.length === 1 && value === '6') || // Validate first digit (only 6)
                      (value.length > 1 && /^6\d*$/.test(value) && value.length <= 8) // Validate up to 8 digits
                    ) {
                      handleDynamicFieldChange(setContactTelephoneNumbers, index, value);
                    }
                  }}
                />
                {contactTelephoneNumbers.length > 1 && (
                  <IconButton onClick={() => setContactTelephoneNumbers((prev) => prev.filter((_, i) => i !== index))} color="error">
                    <Delete />
                  </IconButton>
                )}
                {/* Only display the + icon for the first field */}
                {index === 0 && (
                  <IconButton onClick={() => setContactTelephoneNumbers((prev) => [...prev, ''])} color="primary">
                    <Add />
                  </IconButton>
                )}
              </div>
            ))}


            {/* Contact Emails */}
            {contactEmails.map((email, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <TextField
                  label="Contact Email"
                  variant="outlined"
                  fullWidth
                  required
                  value={email}
                  onChange={(e) => handleDynamicFieldChange(setContactEmails, index, e.target.value)}
                />
                {contactEmails.length > 1 && (
                  <IconButton onClick={() => setContactEmails((prev) => prev.filter((_, i) => i !== index))} color="error">
                    <Delete />
                  </IconButton>
                )}
                {/* Only display the + icon for the first field */}
                {index === 0 && (
                  <IconButton onClick={() => setContactEmails((prev) => [...prev, ''])} color="primary">
                    <Add />
                  </IconButton>
                )}
              </div>
            ))}
          </div>
        ))}

        <Button type="submit" variant="contained" color="primary" fullWidth>
          Submit
        </Button>
        <Button
          className="btn btn-danger"
          onClick={handleNavigate}
          style={{
            borderRadius: '5px',
            boxShadow: '0px 0px 5px 0px #888888',
            backgroundColor: 'red',
            color: 'white',
          }}
        >
          Cancel
        </Button>
      </form>

      {/* Success message Snackbar */}
      <Snackbar
        open={openSuccessSnackbar}
        message="Form submitted successfully!"
        autoHideDuration={2000} // Message will hide after 2 seconds
        onClose={() => setOpenSuccessSnackbar(false)}
      />
    </Box>
  );
};

export default Newcompany;
